const DialogFlowButton = ({
  label,
  onClick,
  type,
  isAgentChat,
  action,
  brandId,
  sessionId,
}) => {
  const useIntroStyle =
    type === "INTRO_MESG" ||
    (action === "dialogFlowButton" &&
      (brandId === "LD" && sessionId != null));

    return (
    <button
      className={
        useIntroStyle
          ? "py-2.5 px-4 rounded-[18px] font-medium text-brand-text-intro bg-brand-bg-intro"
          : "p-2 font-medium text-brand-text-dialog min-h-12 bg-brand-bg-dialog border border-brand-border-dialog rounded-2xl min-w-60"
      }
      onClick={
        isAgentChat
          ? () => {
              alert("상담원과 채팅중에는 사용 할 수 없습니다");
            }
          : onClick
      }
    >
      {label}
    </button>
  );
};

export default DialogFlowButton;
